export default function (maturity) {
  return maturity === 0 ? 'Indefinite' : maturity
}
